import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  isFunction as _isFunction,
  isObject as _isObject,
  isUndefined as _isUndefined,
  isNull as _isNull,
  filter as _filter,
  toLower as _toLower,
} from 'lodash';
import PropTypes from 'prop-types';

import { colorPropType } from '../../Utils/PropTypesValidators';
import { withTheme, LightThemeColors, getThemeImages } from '../Themes';

import Options from './Options';
import styles from './VFDropdown.Styles';
import VFDropdownInput from './VFDropdownInput';

class VFDropdown extends React.Component {
  constructor(props) {
    super(props);
    let selectedItem;
    if (props.defaultValue || props.defaultValue === 0) {
      selectedItem = props.items.find(item => item.value === props.defaultValue);
    } else if (
      props.items.filter(item => item.hasOwnProperty('selected') && item.selected === true).length >
      0
    ) {
      selectedItem = props.items.filter(
        item => item.hasOwnProperty('selected') && item.selected === true,
      )[0];
    } else {
      selectedItem = {
        label: null,
        value: null,
      };
    }
    const defaultValueIndex = props.items.findIndex(item => item.value === props.defaultValue);
    this.searchInputRef = React.createRef();
    this.state = {
      selectedItem: {
        label: selectedItem.label,
        value: selectedItem.value,
      },
      searchInput: '',
      isVisible: props.isVisible,
      initialScroll: props.autoScrollToDefaultValue,
      defaultValueIndex,
    };
    this.dropdownCoordinates = [];
  }

  onSelectItem = item => {
    const { onValueChange, onClose, isSearchable } = this.props;
    this.setState(
      {
        selectedItem: {
          label: item.label,
          value: item.value,
        },
        isVisible: false,
      },
      () => {
        isSearchable && this.searchInputRef.current?.blur();
      },
    );
    isSearchable && this.handleSearchInput(item.value);
    _isFunction(onValueChange) && onValueChange(item.value);
    _isFunction(onClose) && onClose();
  };

  getLayout = layout => {
    this.setState({
      top: layout.height - 1,
    });
  };

  getLabel = item => {
    let label;
    if (_isObject(item)) {
      label = item.label;
    } else if (!_isNull(item) && !_isUndefined(item)) {
      label = item;
    }
    return label;
  };
  getItems() {
    const { items, isSearchable } = this.props;
    if (isSearchable && this.state.searchInput) {
      return _filter(items, item => {
        const itemValue = _toLower(item.value);
        const inputValue = _toLower(this.state.searchInput);
        return itemValue.indexOf(inputValue) > -1;
      });
    }

    return items;
  }
  close = (setState = true) => {
    const { onClose, isSearchable, setDisableScrollViewPanResponder } = this.props;
    this.setState(
      {
        ...(setState && { isVisible: false }),
      },
      () => _isFunction(onClose) && onClose(),
    );
    isSearchable &&
      _isFunction(setDisableScrollViewPanResponder) &&
      setDisableScrollViewPanResponder(false);
  };

  open = (setState = true) => {
    const { onOpen, isSearchable, setDisableScrollViewPanResponder } = this.props;
    this.setState(
      {
        ...(setState && { isVisible: true }),
      },
      () => _isFunction(onOpen) && onOpen(),
    );
    isSearchable &&
      _isFunction(setDisableScrollViewPanResponder) &&
      setDisableScrollViewPanResponder(true);
  };

  toggle = () => {
    const { isVisible } = this.state;
    this.setState(
      {
        isVisible: !isVisible,
      },
      () => {
        if (this.state.isVisible) {
          this.open(false);
        } else {
          this.close(false);
        }
      },
    );
  };
  handleSearchInputFocus = () => {
    this.searchInputRef.current?.focus();
    this.toggle();
  };
  handleSearchInput = value => {
    const { onSearchInputChange } = this.props;
    this.setState({
      searchInput: value,
    });
    _isFunction(onSearchInputChange) && onSearchInputChange(value);
  };

  render() {
    const { selectedItem, isVisible, top } = this.state;
    const {
      isDisabled,
      containerStyle,
      dropDownStyle,
      placeholder,
      flatListProps,
      zIndex,
      theme,
      containerProps,
      arrowStyle,
      style,
      selectedLabelStyle,
      isArrowShown,
      activeItemStyle,
      itemStyle,
      itemTextStyle,
      activeItemTextStyle,
      labelStyle,
      labelProps,
      renderItem,
      isSearchable,
      cursorColor,
      textColor,
      borderColor,
      activeBorderColor,
      images,
      isItemWithImage,
      itemImageStyle,
      itemImageSize,
      labelFontSize,
      searchInputFontSize,
      titleStyle,
      optionsStyle,
      dropDownStyles,
    } = this.props;
    const isPlaceholderActive =
      this.state.selectedItem.label === null ||
      (Array.isArray(this.state.selectedItem) && this.state.selectedItem.length === 0);

    const label =
      isPlaceholderActive || isSearchable
        ? placeholder.label
        : this.getLabel(this.state.selectedItem?.label, true);

    const placeholderStyle = isPlaceholderActive && this.props.placeholderStyle;
    const opacity = isDisabled ? 0.5 : 1;

    const Images = getThemeImages(theme.name);
    const arrowIcon = !isVisible ? Images.ic_chevron_down : Images.ic_chevron_up;
    const items = this.getItems();

    return (
      <View
        style={[styles.containerStyle(isSearchable, zIndex), containerStyle]}
        {...containerProps}
      >
        <VFDropdownInput
          theme={theme}
          getLayout={this.getLayout}
          toggle={this.toggle}
          open={this.open}
          close={this.close}
          isDisabled={isDisabled}
          label={label}
          placeholderStyle={placeholderStyle}
          titleStyle={titleStyle}
          opacity={opacity}
          labelStyle={labelStyle}
          isArrowShown={isArrowShown}
          selectedItem={selectedItem}
          selectedLabelStyle={selectedLabelStyle}
          labelProps={labelProps}
          isVisible={isVisible}
          arrowStyle={arrowStyle}
          arrowIcon={arrowIcon}
          style={style}
          handleSearchInputFocus={this.handleSearchInputFocus}
          handleSearchInput={this.handleSearchInput}
          isSearchable={isSearchable}
          searchInput={this.state.searchInput}
          forwardedRef={this.searchInputRef}
          cursorColor={cursorColor}
          textColor={textColor}
          borderColor={borderColor}
          activeBorderColor={activeBorderColor}
          labelFontSize={labelFontSize}
          searchInputFontSize={searchInputFontSize}
          {...this.props}
        />
        <View style={[styles.dropDownBox(top, zIndex), dropDownStyle, !isVisible && styles.hidden, dropDownStyles]}>
          <Options
            items={items}
            dropdownCoordinates={this.dropdownCoordinates}
            getFlatListRef={ref => (this.flatListRef = ref)}
            onSelectItem={this.onSelectItem}
            selectedItem={selectedItem}
            activeItemStyle={activeItemStyle}
            itemStyle={itemStyle}
            activeItemTextStyle={activeItemTextStyle}
            itemTextStyle={itemTextStyle}
            labelProps={labelProps}
            getLabel={this.getLabel}
            flatListProps={flatListProps}
            renderItem={renderItem}
            isItemWithImage={isItemWithImage}
            itemImageStyle={itemImageStyle}
            itemImageSize={itemImageSize}
            images={images}
            theme={theme}
            optionsStyle={optionsStyle}
          />
        </View>
      </View>
    );
  }
}

VFDropdown.defaultProps = {
  theme: LightThemeColors,
  placeholder: {
    label: '',
  },
  style: {},
  dropDownStyle: {},
  containerStyle: {},
  itemStyle: {},
  labelStyle: {},
  selectedLabelStyle: {},
  placeholderStyle: {},
  activeItemStyle: {},
  arrowStyle: {},
  arrowColor: '#000',
  isArrowShown: true,
  arrowSize: 15,
  customTickIcon: () => null,
  zIndex: 1,
  isDisabled: false,
  isSearchable: false,
  isVisible: false,
  autoScrollToDefaultValue: false,
  labelProps: {},
  flatListProps: {},
  containerProps: {},
  onOpen: () => { },
  onClose: () => { },
  isItemWithImage: false,
  itemImageSize: 32,
  labelFontSize: 14,
  searchInputFontSize: 16,
};

VFDropdown.propTypes = {
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  containerProps: PropTypes.object,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.objectOf({
    label: PropTypes.string,
  }),
  isArrowShown: PropTypes.bool,
  item: PropTypes.objectOf({
    isDisabled: PropTypes.bool,
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  items: PropTypes.array,
  autoScrollToDefaultValue: PropTypes.bool,
  isVisible: PropTypes.bool,
  isSearchable: PropTypes.bool,
  labelProps: PropTypes.object,
  isDisabled: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onValueChange: PropTypes.func,
  onSearchInputChange: PropTypes.func,
  flatListProps: PropTypes.object,
  zIndex: PropTypes.number,
  placeholderStyle: ViewPropTypes.style,
  selectedLabelStyle: ViewPropTypes.style,
  titleStyle: ViewPropTypes.style,
  arrowStyle: ViewPropTypes.style,
  dropDownStyle: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  activeItemStyle: ViewPropTypes.style,
  itemStyle: ViewPropTypes.style,
  labelStyle: ViewPropTypes.style,
  renderItem: PropTypes.func,
  cursorColor: colorPropType,
  textColor: colorPropType,
  borderColor: colorPropType,
  activeBorderColor: colorPropType,
  isItemWithImage: PropTypes.bool,
  itemImageStyle: ViewPropTypes.style,
  itemImageSize: PropTypes.number,
  images: PropTypes.object,
  itemTextStyle: ViewPropTypes.style,
  activeItemTextStyle: ViewPropTypes.style,
  labelFontSize: PropTypes.number,
  searchInputFontSize: PropTypes.number,
  setDisableScrollViewPanResponder: PropTypes.func,
};

export default withTheme(VFDropdown);
